import { SpeechBubbleM } from "@common/components/speech-bubble/SpeechBubbleM"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { whatIsIt } from "@data/utility/Utils"
import React, { useContext, useImperativeHandle, useRef, useState } from "react"
import { Platform, View } from "react-native"
import { connect } from "react-redux"
import { ChampionImageM } from "./ChampionImageM"

const ChampionBubble = React.forwardRef((props, ref) => {
    const {
        name,
        variant,
        texts,
        onNextPress,
        championPosition,
        style,
        noAnimation = false,
        allowSpeechReplay = false,
        hideIcons = true,
        width = null,
        onAnimationComplete,
        feedbackButtons,
        championWidthCenter = 140,
        customContent = null,
    } = props

    const championWidthLeft = 90
    const paddingHorizontalLeft = 20

    const speechBubbleRef = useRef()

    const isVariantArray = whatIsIt(variant) === "Array"
    const [variantIndex, setVariantIndex] = useState(0)
    const goToNextVariant = () => {
        if (variantIndex < variant?.length - 1)
            setVariantIndex((index) => index + 1)
    }
    const dimensions = useContext(DimensionsContext)

    useImperativeHandle(ref, () => ({
        onChampionBubbleNext() {
            if (isVariantArray) {
                goToNextVariant()
            }
            speechBubbleRef.current?.onSpeechBubblePress()
        },
    }))

    if (championPosition === "left") {
        return (
            <View
                style={{
                    flexDirection: "row",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    width: width ? width : dimensions?.width,
                    paddingLeft: paddingHorizontalLeft,
                    paddingRight: paddingHorizontalLeft + 10,
                    alignSelf: "center",
                    ...style,
                }}
            >
                <ChampionImageM
                    name={name}
                    variant={isVariantArray ? variant[variantIndex] : variant}
                    width={championWidthLeft}
                    height={Platform.OS === "web" ? 140 : null}
                    animated={props.animated}
                    animationKey={props.animationKey}
                    isLoading={props.isLoading}
                />
                <View>
                    {customContent ? (
                        customContent
                    ) : (
                        <SpeechBubbleM
                            ref={speechBubbleRef}
                            allowSpeechReplay={allowSpeechReplay}
                            hideIcons={hideIcons}
                            texts={texts}
                            noAnimation={noAnimation}
                            onNextPress={onNextPress}
                            position={championPosition}
                            feedbackButtons={feedbackButtons}
                            isLoading={props.isLoading}
                            containerStyle={{
                                width:
                                    (width ? width : dimensions?.width) -
                                    championWidthLeft -
                                    paddingHorizontalLeft * 2 -
                                    10,
                                marginLeft: 10,
                                marginBottom: 6,
                            }}
                            textStyle={{
                                textAlign: "left",
                                fontSize: 15,
                            }}
                            numberOfSpeechLines={props.numberOfSpeechLines}
                            onAnimationComplete={onAnimationComplete}
                        />
                    )}
                </View>
            </View>
        )
    } else {
        return (
            <View
                style={{
                    flex: 1,
                    alignItems: "center",
                    justifyContent: "flex-end",
                    width: dimensions?.width,
                    paddingBottom: 60,
                    ...style,
                }}
            >
                <SpeechBubbleM
                    ref={speechBubbleRef}
                    texts={texts}
                    noAnimation={noAnimation}
                    onNextPress={onNextPress}
                    containerStyle={{
                        width:
                            Platform.OS !== "web"
                                ? dimensions?.width - 40
                                : dimensions?.width / 1.5,
                        marginTop: 40,
                        marginBottom: 20,
                        marginHorizontal: 20,
                    }}
                    textStyle={{
                        textAlign: "center",
                        fontSize: 16,
                    }}
                />

                <ChampionImageM
                    name={name}
                    variant={isVariantArray ? variant[variantIndex] : variant}
                    width={championWidthCenter ?? 140}
                    {...(!championWidthCenter && {
                        height: Platform.OS === "web" ? 230 : null,
                    })}
                />
            </View>
        )
    }
})

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
    }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps, null, {
    forwardRef: true,
})(ChampionBubble)
